import { Box, IconButton, Skeleton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { BalootUserV2APIs } from "../../api/APIs";
import { useRequest } from "../../api/utils/useRequest";
import AppBarContainer from "../../components/shared/AppBarContainer";
import { ReactComponent as NotifIcon } from "../../assets/icons/notif-icon.svg";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AssetAmountAndRateCard from "../../components/home/AssetAmountAndRateCard";
import HomeWalletCard from "../../components/home/HomeWalletCard";
import PageContentContainer from "../../components/shared/PageContentContainer";
import StartDirectDebitBanner from "../../components/home/StartDirectDebitBanner";
import StartManualInvestBanner from "../../components/home/StartManualInvestBanner";
import ActiveDirectDebitBanner from "../../components/home/ActiveDirectDebitBanner";
import Last30DaysInvestment from "../../components/home/Last30DaysInvestment";
import ReferralBanner from "../../components/home/ReferralBanner";
import { useDispatch, useSelector } from "react-redux";
import CustomRectangularSkeleton from "../../components/shared/CustomRectangularSkeleton";
import { useNavigate } from "react-router-dom";
import { setConfig } from "../../store/actions/ConfigActions";

function HomePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showRate, setShowRate] = useState(false);
  const { config } = useSelector((state) => state.config);

  const {
    loading,
    apiCall: getUserStats,
    result: userStat,
  } = useRequest(BalootUserV2APIs.userStats);

  useEffect(() => {
    getUserStats({
      onSuccess: (response) => {
        dispatch(
          setConfig({
            config: {
              personalInfo: {
                ...config.personalInfo,
                firstName: response.firstName,
              },
            },
          })
        );
      },
    });
  }, []);

  return (
    <>
      <AppBarContainer
        rightElement={
          <Typography variant="h5" color={"common.white"}>
            {`سلام، ${config.personalInfo?.firstName || "کاربر"} عزیز`}
          </Typography>
        }
        leftElement={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={() => {
                setShowRate((prev) => !prev);
              }}
            >
              {showRate ? (
                <VisibilityOffOutlinedIcon sx={{ color: "common.white" }} />
              ) : (
                <RemoveRedEyeOutlinedIcon sx={{ color: "common.white" }} />
              )}
            </IconButton>
            <Box
              onClick={() => {
                navigate("/app/messages");
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                ml: "8px",
                position: "relative",
              }}
            >
              {userStat && userStat?.hasNewMessage && (
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    bgcolor: "red.main",
                    position: "absolute",
                    borderRadius: "100%",
                    top: 8,
                    left: 8,
                  }}
                />
              )}
              <NotifIcon />
            </Box>
          </Box>
        }
      />
      <Box
        sx={{
          overflow: "auto",
          flex: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <AssetAmountAndRateCard
            loading={loading}
            assetAmount={userStat?.assetAmount}
            rate={userStat?.returnStat?.rate}
            showRate={showRate}
          />
          <HomeWalletCard amount={userStat?.wallet?.amount} loading={loading} />
        </Box>
        <PageContentContainer sx={{ mt: "12px", display: "block" }}>
          {loading ? (
            <>
              <CustomRectangularSkeleton height={90} />
              <CustomRectangularSkeleton height={90} sx={{ mt: 2 }} />
              <CustomRectangularSkeleton height={90} sx={{ mt: 2 }} />
            </>
          ) : (
            userStat && (
              <>
                {userStat?.subscription?.suggestion ? (
                  <StartDirectDebitBanner />
                ) : (
                  <ActiveDirectDebitBanner
                    subscription={userStat?.subscription}
                  />
                )}
                <Box sx={{ width: "100%", mt: "12px" }}>
                  <StartManualInvestBanner />
                </Box>
                <Box sx={{ width: "100%", mt: "12px" }}>
                  {userStat?.lastInvestment && (
                    <Last30DaysInvestment
                      lastInvestment={userStat?.lastInvestment}
                    />
                  )}
                </Box>
                {userStat?.campaign && (
                  <Box sx={{ width: "100%", mt: "12px" }}>
                    <ReferralBanner campaign={userStat?.campaign} />
                  </Box>
                )}
              </>
            )
          )}
        </PageContentContainer>
      </Box>
    </>
  );
}

export default HomePage;
